<template>
    <div>
        <div class="bg-leave-liff" v-if="!isConsent">
            <div class="header-text line-register">
                <span
                    v-if="!showRegistrationResult">
                        {{ this.$vuetify.lang.t('$vuetify.lineRegister.privacyPolicy') }}
                </span>
                <span
                    v-else>
                        {{ this.$vuetify.lang.t('$vuetify.lineRegister.headerRegister') }}
                </span>
            </div>

            <line-register-result
                v-if="showRegistrationResult"
                ref="lineRegisterResult"
                :result="registrationResult">
            </line-register-result>

            <v-form
                v-else
                ref="form"
                class="form-container"
                :class="{ 'content-loaded': dataLoaded }">
                <div v-for="(consent, key_consent) in consents" :key = key_consent>
                    <div class="label-tag-header" v-if="consent.header">
                        <span>
                            {{ consent.header }}
                        </span>
                    </div>
                    <div v-if="consent.infos">
                        <div class="label-tag mt-2" v-for="(info, key_info) in consent.infos" :key = key_info>
                            <span>
                                {{ info }}
                            </span>
                        </div>
                    </div>
                    <div :class="consent.header == null ? '' : 'label-block'">
                        <div class="label-tag" v-for="(section, key_section) in consent.sections" :key = key_section>
                            <div v-if="section.topics">
                                <div class="label-tag" v-for="(topic, key_topic) in section.topics" :key = key_topic>
                                    <span>
                                        {{ topic }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="section.details">
                                <div class="label-block" v-for="(detail, key_detail) in section.details" :key = key_detail>
                                    <span>
                                        {{ detail }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-center register-btn">
                    <v-btn
                        v-show="dataLoaded"
                        color="primary"
                        @click="submitConsent()">
                        {{ this.$vuetify.lang.t('$vuetify.lineRegister.agree') }}
                    </v-btn>
                </div>
            </v-form>
        </div>
        <line-register-reg-code
            v-if="isConsent && lineLiffId"
            ref="lineRegisterModal"
            :line-liff-id="lineLiffId"
            :is-consent="isConsent"
        />
    </div>
</template>

<script>
import LineRegisterRegCode from '@/components/Liff/LineRegisterRegCode'
import LineRegisterResult from '@/components/Liff/LineRegisterResult'

export default {
    name: 'LineRegister',

    components: {
        LineRegisterRegCode,
        LineRegisterResult
    },

    data () {
        return {
            lineLiffId: process.env.VUE_APP_LINE_LIFF_REGISTER,
            isConsent: false,
            consents: null,
            showRegistrationResult: false,
            dataLoaded: false,
            registrationResult: {
                header: '',
                content: '',
                status: ''
            }
        }
    },

    methods: {
        submitConsent () {
            this.isConsent = true
        },

        async getLineRegister () {
            const lineUserId = await this.$liffUtil.getLineIdForLiff(this.lineLiffId)
            const res = await this.axios.post('line/check-register', { line_id: lineUserId })
            if (res && res.data && res.data.status === 'ok') {
                this.registrationResult.header = 'ลงทะเบียนสำเร็จ'
                this.registrationResult.content = res.data.msg
                this.registrationResult.status = 'ok'
                this.showRegistrationResult = true
            }
            if (res && res.data && res.data.status === 'error') {
                this.registrationResult.header = 'ไม่พบรหัสลงทะเบียนนี้'
                this.registrationResult.content = res.data.msg
                this.registrationResult.status = 'error'
                this.showRegistrationResult = true
            }
        }
    },

    async mounted () {
        this.$store.dispatch('setLoading', true)
        this.dataLoaded = false
        await this.getLineRegister()
        this.consents = JSON.parse(this.$vuetify.lang.t('$vuetify.lineRegister.lineConsent'))
        this.dataLoaded = true
        this.$store.dispatch('setLoading', false)
    }

}
</script>

<style lang="scss" scoped>
    .bg-leave-liff {
        background-color: #2E2929;
        color: #ffffff;
        height: 100vh;
    }

    .header-text {
        font-family: Prompt;
        font-size: 20px;
        padding: 1rem;
        height: 5%;
        min-height: 45px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .form-container {
        background: #ffffff;
        border-top-right-radius: 15px;
        border-top-left-radius: 15px;
        padding: 0.5rem 1rem 0.5rem 1rem;
        color: #6c6c6c;
        font-size: 14px;
        font-weight: normal;
        overflow: scroll;
        height: 95%;
        text-align: justify;

        // transition on data loaded
        visibility: hidden;
        opacity: 0;
        transition: visibility 0s, opacity 0.5s linear;
        &.content-loaded {
            visibility: visible;
            opacity: 1;
        }
    }

    .label-tag-header {
        font-family: Sarabun-Bold !important;
        font-size: 14px;
        font-weight: 600;
        color: #131410;
        padding-top: 0.5rem;
        padding-bottom: 0.1rem;
        white-space: pre-line;
    }

    .label-block {
        padding-left: 1rem;
    }

    .label-tag span {
        font-family: Sarabun !important;
        font-size: 14px;
        color: #131410;
        white-space: pre-line;
        overflow-wrap: break-word;
    }

    .flex-center .v-btn {
        font-family: Prompt !important;
        font-size: 18px;
        display: flex;
        justify-content: center;
        height: 40px;
        width: 100%;
    }

    .register-btn {
        margin-top: 12px;
        margin-bottom: 30px;
    }
    ::v-deep .v-btn {
    .v-btn__content {
        font-family: Prompt !important;
    }
    }
</style>
